import { render, staticRenderFns } from "./ARParticipant.vue?vue&type=template&id=16860fea&scoped=true"
import script from "./ARParticipant.vue?vue&type=script&lang=js"
export * from "./ARParticipant.vue?vue&type=script&lang=js"
import style0 from "./ARParticipant.vue?vue&type=style&index=0&id=16860fea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16860fea",
  null
  
)

export default component.exports